import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO, ResponseCode} from "@app/constants/Common";
import {Modal} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Select from "react-select";
import {requestGetJobList} from "@app/services/JobService";
import {CopyPipelineTypesOptions} from "@pages/job/common/Constant";
import {requestCompareCandidatesFromList, requestCopyPipelineFromJob} from "@app/services/JobPipelineService";
import {alertMessage, getMessageFromCode} from "@app/constants/Messages";

const CopyPipelinesModal = (props) => {
    const [isLoading, setLoading] = useState(false);
    const [selectJob, setSelectJob] = useState({});
    const [selectCopyType, setSelectCopyType] = useState({});
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [failedCopyPipelines, setFailedCopyPipelines] = useState([]);
    const [selectJobOptions, setSelectJobOptions] = useState([]);

    const {currentJobId, isShow, onClose} = props

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])



    const fetchJobList = async () => {
        const res = await requestGetJobList({unlimited: true});
        const jobOptionList = res.content.jobs.map((item) => {
            return  {value: item.id, label : item.job_name}
        });
        setSelectJobOptions(jobOptionList);
    }

    const onSelectJob = (jobOption) => {
        setSelectJob(jobOption)
    }

    const onSelectCopyType = (copyTypeOption) => {
        setSelectCopyType(copyTypeOption)
    }

    const onCopyPipelines = () => {
        const body = {source_job_id: selectJob.value, target_job_id: currentJobId, copy_type: selectCopyType.value}
        setLoading(true);
        requestCopyPipelineFromJob(body).then((res) => {
            alertMessage(res.sts_code, false, true)
            if (res.sts_code === ResponseCode.SUCCESS) {
                setFailedCopyPipelines(res.content.failed_copy_pipelines)
            }
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
        }).finally(() => {
            setLoading(false);
        });
    }

    useEffect(() => {
        fetchJobList().then()
    },[]);

    return (
        <Modal show={isShow}
               size={"xl"}
               onHide={onClose}
               animation={false}>
            <Modal.Header>
                <Modal.Title>Copy lists from job tương tự</Modal.Title>
                <Button variant='secondary' onClick={onClose}>
                    Close
                </Button>
            </Modal.Header>
            <Modal.Body>
                <div className='container-fluid'>
                    <div className="card card-default">
                        <div className="card-body">
                            <div className='col-sm-6'>
                                <div className='form-group'>
                                    <label className={'w-100'}>Job nguồn</label>
                                    <Select options={selectJobOptions}
                                            placeholder={"Chọn job"}
                                            value={selectJob}
                                            onChange={values => {
                                                onSelectJob(values);
                                            }}
                                    />
                                </div>
                            </div>
                            <div className='col-sm-6 mt-3'>
                                <label className={'w-100'}>Loại copy</label>
                                <Select options={CopyPipelineTypesOptions}
                                        className={'w-100'}
                                        name={'copy_type'}
                                        value={selectCopyType}
                                        onChange={values => onSelectCopyType(values)}>
                                </Select>
                            </div>
                            <div className='col-sm-6 mt-3'>
                                <Button variant='primary' onClick={onCopyPipelines} disabled={!selectJob.value || !selectCopyType.value}>
                                    Copy
                                </Button>
                            </div>
                        </div>
                    </div>
                    {failedCopyPipelines.length > 0 &&
                    <div className={"card card-default"}>
                        <div className='card-header'>
                            <h3 className='card-title text-bold'>Danh sách pipelines copy lỗi</h3>
                        </div>
                        <div className={"card-body"}>
                            {failedCopyPipelines.length > 0 &&
                            <div className='card-body table-responsive'>
                                <table
                                    className='table table-hover table-bordered text-nowrap text-center'
                                    style={{
                                        maxHeight: '80vh',
                                        overflow: 'scroll',
                                    }}
                                >
                                    <thead>
                                    <tr>
                                        <th>STT</th>
                                        <th>Job ID</th>
                                        <th>Persion ID</th>
                                        <th>Process nội bộ</th>
                                        <th>Notes</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {failedCopyPipelines.map((item, index) => {
                                        return <tr key={`compare-candidate-excel_${index}`}>
                                            <td>{index + 1}</td>
                                            {/*<td>{can.id}</td>*/}
                                            <td>{item.job_id}</td>
                                            <td>{item.candidate_id}</td>
                                            <td>{item.internal_process}</td>
                                            <td>{getMessageFromCode(item.error_code)}</td>
                                            {/*{Object.keys(row).map(field => (*/}
                                            {/*    <td key={`compare-candidate-excel-${index}-${field}`}>{arrayToString(row[field])}</td>*/}
                                            {/*))}*/}
                                        </tr>
                                    })}
                                    </tbody>
                                </table>
                            </div>
                            }
                        </div>
                    </div>
                    }
                </div>
            </Modal.Body>
        </Modal>

    );
};

export default CopyPipelinesModal;
